import { objectKeys } from "app/helpers/objects";
import type { LeadsTechColumnType } from "app/pages/sales-intelligence/modules/leads-search";
import type { TechnologiesConditionEntry } from "app/pages/sales-intelligence/sub-modules/advanced-search/models/filters/technology/types";
import { TechnologiesConditionTypeEnum } from "app/pages/sales-intelligence/sub-modules/advanced-search/models/filters/technology/types";

const TechnographicsTypeMap: Record<LeadsTechColumnType, TechnologiesConditionTypeEnum> = {
    tech: TechnologiesConditionTypeEnum.Technology,
    techSubCategory: TechnologiesConditionTypeEnum.SubCategory,
    techCategory: TechnologiesConditionTypeEnum.Category,
};

const createTechnographicsService = () => {
    const getColumnType = (columnName: string | undefined) =>
        objectKeys(TechnographicsTypeMap).find((type) => columnName?.startsWith(`${type}:`));

    const getDisplayName = (columnName: string | undefined) => {
        const type = getColumnType(columnName);
        return columnName?.replace(`${type}:`, "");
    };

    const getEntry = (value: string | undefined) => {
        const type = getColumnType(value);

        return type && value
            ? {
                  type: TechnographicsTypeMap[type],
                  name: value,
              }
            : undefined;
    };

    const setValueFromEntry = (entry: TechnologiesConditionEntry) => {
        const type = objectKeys(TechnographicsTypeMap).find((key) => TechnographicsTypeMap[key] === entry.type);
        return type ? `${type}:${entry.name}` : "";
    };

    return {
        getDisplayName,
        setValueFromEntry,
        getEntry,
    };
};

const technographicsService = createTechnographicsService();
export default technographicsService;
